import { gql } from '@apollo/client';

export const ALL_ASSIGNED_USERS_TO_ACTIVITY = gql`
  query AllAssignedUsersToActivity($input: AllAssignedUsersToActivityInput!) {
    userActivities: allAssignedUsersToActivity(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          user {
            id
            firstName
            lastName
          }
          activity {
            name
          }
          role
          endDate
          startDate
        }
      }
    }
  }
`;
